var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMusicIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3208 0.931156C18.9812 0.931156 24.3767 6.33953 24.3767 13C24.3767 19.6733 18.9812 25.0689 12.3208 25.0689C5.64743 25.0689 0.251953 19.6733 0.251953 13C0.251953 6.33953 5.64743 0.931156 12.3208 0.931156Z",
    fill: "#FF2682"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.518 8.17064C15.7568 7.70479 15.1774 6.83003 15.0297 5.95518C15.007 5.75068 14.9729 5.58023 14.9729 5.37573H12.6779V10.7837V14.533C12.6779 15.601 11.8031 16.4757 10.7352 16.4757C10.3829 16.4757 10.0875 16.3848 9.80347 16.2485C9.18997 15.9304 8.75826 15.2601 8.75826 14.533C8.75826 13.4536 9.62176 12.5789 10.7352 12.5789C10.9283 12.5789 11.11 12.6129 11.3145 12.6698V10.8633V10.3407C11.11 10.3179 10.9283 10.2838 10.7352 10.2838C8.37196 10.2838 6.46326 12.1812 6.46326 14.533C6.46326 15.9531 7.17901 17.237 8.29241 17.9868C8.98546 18.4526 9.82626 18.748 10.7352 18.748C13.0869 18.748 14.9729 16.8507 14.9729 14.533V9.76124C15.8477 10.5452 17.0066 10.9314 18.1654 10.8405V9.12494V8.54559C17.586 8.65919 17.0066 8.48874 16.518 8.17064Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMusicIcon);
export default __webpack_public_path__ + "static/media/music_icon.8c8254218f7974c7efc67b36365c2759.svg";
export { ForwardRef as ReactComponent };